import { Component, Input } from '@angular/core';
import { OnboardingModuleStatuses } from 'src/app/core/enums/onboarding-module-status.enum';
import { IDashboardChecklistItem } from 'src/app/core/interfaces/common/ui/dashboard-checklist-item.interface';

@Component({
  selector: 'app-dashboard-checklist',
  templateUrl: './dashboard-checklist.component.html',
  styleUrls: ['./dashboard-checklist.component.scss'],
})
export class DashboardChecklistComponent {
  @Input() checklistItems: IDashboardChecklistItem[];
  checkListStatuses = OnboardingModuleStatuses;
}
